import { useContext, useState } from 'react'
import styled from 'styled-components'
import isEmail from 'validator/lib/isEmail'
import { AdaptedFormInput } from '../form/fields'
import { States, ValidationUserContext } from './modal'
import { BackButton } from './back-button'
import { editUserById } from 'shared/api'
import { Container, Emoji, Title, Button, Message, Email, Footer, PrimaryButton } from './styled'

const StyledAdaptedFormInput = styled(AdaptedFormInput)`
    width: 355px;
`

const UpdatingEmail = () => {
    const { user, changeState, setNewEmail } = useContext(ValidationUserContext)
    const [email, setEmail] = useState('')
    const [error, setError] = useState<string | null>(null)

    const onValidateAccount = () => {
        if (email === user.email) {
            setError('Uh-oh. Please enter a new email address.')
            return
        }
        if (!isEmail(email)) {
            setError("Uh-oh. We don't recognize that email address.")
            return
        }

        editUserById(user.id, { email, platform: 'web', source: 2 }, true)
            .then(() => {
                setNewEmail(email)
                changeState(States.SUCCESS_EMAIL_CHANGE)
            })
            .catch(() => {
                setNewEmail(email)
                changeState(States.INVALID_EMAIL)
            })
    }
    const logout = () => {
        window.location.href = '/logout'
    }

    return (
        <Container>
            {user.is_email_deliverable && <BackButton onClick={() => changeState(States.VALID_EMAIL)} />}
            <Emoji src="https://media2.giphy.com/media/USUIWSteF8DJoc5Snd/200w.gif" />
            <Title>Updating Your Email?</Title>
            <Message>{`Please enter your new email below.`}</Message>
            <StyledAdaptedFormInput
                errorTooltip
                errorMessage={error}
                borderRadius={2}
                inputProps={{
                    placeholder: 'Email address',
                    type: 'email',
                    value: email,
                    onChange: (e) => setEmail(e.target.value),
                }}
            />
            <PrimaryButton onClick={onValidateAccount}>Validate My Account</PrimaryButton>
            <Button onClick={logout}>Log out</Button>
            <Footer>
                {`Need help? Please reach out to `}
                <Email>support@giphy.com</Email>
            </Footer>
        </Container>
    )
}

export default UpdatingEmail
